export * from "./frames";
export * from "./token";

/**
 * Container extension for a mime type. `MediaRecorder` gives
 * `audio/webm;codecs=opus` (Chrome, Firefox) or `audio/mp4` (Safari); an
 * uploaded file can be anything a phone or a laptop saves audio as. ffmpeg
 * probes the bytes rather than trusting the name, so the extension only has to
 * be honest enough for playback to send the right Content-Type.
 */
export function audioExtension(mimeType: string): string {
  const base = mimeType.split(";")[0].trim().toLowerCase();
  switch (base) {
    case "audio/webm":
    case "video/webm":
      return "webm";
    case "audio/mp4":
    case "audio/m4a":
    case "audio/x-m4a":
      return "m4a";
    case "audio/aac":
    case "audio/x-aac":
      return "aac";
    case "audio/ogg":
    case "audio/opus":
    case "application/ogg":
      return "ogg";
    case "audio/mpeg":
    case "audio/mp3":
      return "mp3";
    case "audio/wav":
    case "audio/x-wav":
    case "audio/wave":
    case "audio/vnd.wave":
      return "wav";
    case "audio/flac":
    case "audio/x-flac":
      return "flac";
    case "video/mp4":
      return "mp4";
    case "video/quicktime":
      return "mov";
    default:
      return "bin";
  }
}

/**
 * Largest file the upload path accepts. Uploads are compacted to speech-grade
 * Opus once transcoded, so this bounds the transient disk peak on the box
 * (chunks + concatenated file + FLAC master), not what is kept.
 */
export const MAX_UPLOAD_BYTES = 500 * 1024 * 1024;
